import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

/**
 * 独立状态
 * @type {{RESET: number, LOADING: number, LOAD_SUCCESS: number, LOAD_FAILED: number, INVALID: number}}
 */
export const LoaderStatus = {
  RESET: 0,
  LOADING: 1,
  LOAD_SUCCESS: 2,
  LOAD_FAILED: 4,
  INVALID: 8,
};

/**
 *
 */
export default class AsyncLoaderController extends Component {
  static get propTypes() {
    return {
      status: PropTypes.number,
      reasonOfFailure: PropTypes.any,
      reasonOfInvalid: PropTypes.any,
      FailureReasonComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
      InvalidReasonComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
      className: PropTypes.string,
      children: PropTypes.any,
    };
  }

  static get defaultProps() {
    return {
      status: LoaderStatus.RESET,
      reasonOfFailure: undefined,
      reasonOfInvalid: undefined,
      FailureReasonComponent: "div",
      InvalidReasonComponent: "div",
      className: undefined,
      children: undefined,
    };
  }

  static get dimmerStatus() {
    return LoaderStatus.LOADING | LoaderStatus.LOAD_FAILED | LoaderStatus.INVALID;
  }

  render() {
    const Self = this.constructor;
    const { className, children, status, reasonOfFailure, reasonOfInvalid } = this.props;
    const { FailureReasonComponent, InvalidReasonComponent } = this.props;
    const hasContent = children && typeof children !== "boolean";
    const hasDimmer = Self.dimmerStatus & status;
    const containerClassName = cx(className, "a-loader", {
      "loader--hasDimmer": hasDimmer,
      "loader--hasContent": hasContent,
      "loader--loading": LoaderStatus.LOADING & status,
      "loader--success": LoaderStatus.LOAD_SUCCESS & status,
      "loader--failed": LoaderStatus.LOAD_FAILED & status,
      "loader--invalid": LoaderStatus.INVALID & status,
    });

    return (
      <div className={containerClassName}>
        {!hasDimmer || (
          <div className="loader__dimmer">
            {!(LoaderStatus.LOADING & status) || (
              <div className="loader__indicator loaderIndicator">
                <i className="loaderIndicator__dot loaderIndicator__dot--first" />
                <i className="loaderIndicator__dot loaderIndicator__dot--second" />
                <i className="loaderIndicator__dot loaderIndicator__dot--third" />
              </div>
            )}
            {!(LoaderStatus.LOAD_FAILED & status) ||
              React.createElement(
                FailureReasonComponent,
                {
                  className: "loader__reason loader__reason--failure",
                },
                reasonOfFailure || "出错了"
              )}
            {!(LoaderStatus.INVALID & status) ||
              React.createElement(
                InvalidReasonComponent,
                {
                  className: "loader__reason loader__reason--invalid",
                },
                reasonOfInvalid || "出错了(400)"
              )}
          </div>
        )}
        {hasContent && <div className="loader__content">{children}</div>}
      </div>
    );
  }
}

require("./async-loader-controller.less");